var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_other_pin)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.167 0.5C23.6102 0.500177 28.833 5.75602 28.833 12.2393C28.8329 20.0476 17.2197 30.4528 17.167 30.5C17.167 30.5 5.50013 20.0653 5.5 12.2393C5.5 5.75591 10.7237 0.5 17.167 0.5ZM17.168 8C15.1098 8.00016 13.4414 9.67903 13.4414 11.75C13.4414 13.821 15.1098 15.4998 17.168 15.5C19.2263 15.5 20.8955 13.8211 20.8955 11.75C20.8955 9.67893 19.2263 8 17.168 8Z",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.167 0.5L17.167 0H17.167V0.5ZM28.833 12.2393L29.333 12.2393V12.2393H28.833ZM17.167 30.5L16.8337 30.8727L17.1671 31.1709L17.5005 30.8725L17.167 30.5ZM5.5 12.2393H5V12.2393L5.5 12.2393ZM17.168 8V7.5H17.1679L17.168 8ZM13.4414 11.75H12.9414V11.75H13.4414ZM17.168 15.5L17.1679 16H17.168V15.5ZM20.8955 11.75H21.3955V11.75H20.8955ZM17.167 0.5L17.167 1C23.3311 1.00017 28.333 6.02921 28.333 12.2393H28.833H29.333C29.333 5.48283 23.8893 0.000184357 17.167 0L17.167 0.5ZM28.833 12.2393L28.333 12.2392C28.333 14.0758 27.647 16.1064 26.5749 18.1475C25.5061 20.1822 24.0745 22.188 22.6316 23.9648C19.7459 27.5183 16.8516 30.1112 16.8335 30.1275L17.167 30.5L17.5005 30.8725C17.5351 30.8416 20.4738 28.2083 23.4079 24.5952C24.8748 22.7888 26.3499 20.7263 27.4602 18.6125C28.5672 16.505 29.333 14.3068 29.333 12.2393L28.833 12.2393ZM17.167 30.5C17.5003 30.1273 17.5003 30.1273 17.5003 30.1273C17.5003 30.1273 17.5002 30.1272 17.5001 30.1271C17.4998 30.1268 17.4994 30.1264 17.4987 30.1259C17.4975 30.1248 17.4956 30.1231 17.493 30.1207C17.4877 30.116 17.4797 30.1088 17.4691 30.0991C17.4478 30.0798 17.4158 30.0508 17.3738 30.0123C17.29 29.9355 17.1663 29.8211 17.0086 29.6725C16.693 29.3751 16.2413 28.9408 15.6987 28.3948C14.6129 27.3024 13.1665 25.766 11.7215 23.989C10.2751 22.2103 8.83849 20.2006 7.76551 18.1613C6.68918 16.1157 6.00003 14.08 6 12.2392L5.5 12.2393L5 12.2393C5.00003 14.3115 5.76929 16.515 6.88053 18.6269C7.99512 20.7453 9.47523 22.8116 10.9456 24.6199C12.4173 26.4297 13.8876 27.9912 14.9894 29.0998C15.5406 29.6544 16.0003 30.0964 16.3228 30.4002C16.484 30.5522 16.6111 30.6697 16.6981 30.7495C16.7416 30.7894 16.7751 30.8198 16.798 30.8405C16.8094 30.8508 16.8181 30.8587 16.8241 30.8641C16.8271 30.8668 16.8294 30.8689 16.831 30.8703C16.8318 30.871 16.8324 30.8716 16.8329 30.872C16.8331 30.8722 16.8333 30.8723 16.8334 30.8724C16.8336 30.8726 16.8337 30.8727 17.167 30.5ZM5.5 12.2393H6C6 6.02914 11.0027 1 17.167 1V0.5V0C10.4446 0 5 5.48268 5 12.2393H5.5ZM17.168 8L17.1679 7.5C14.8307 7.50018 12.9414 9.40582 12.9414 11.75H13.4414H13.9414C13.9414 9.95224 15.3889 8.50014 17.168 8.5L17.168 8ZM13.4414 11.75H12.9414C12.9414 14.0942 14.8307 15.9998 17.1679 16L17.168 15.5L17.168 15C15.3889 14.9999 13.9414 13.5478 13.9414 11.75H13.4414ZM17.168 15.5V16C19.5052 16 21.3955 14.0944 21.3955 11.75H20.8955H20.3955C20.3955 13.5477 18.9473 15 17.168 15V15.5ZM20.8955 11.75H21.3955C21.3955 9.40559 19.5052 7.5 17.168 7.5V8V8.5C18.9473 8.5 20.3955 9.95227 20.3955 11.75H20.8955Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_other_pin",
    x: 0,
    y: 0,
    width: 34.333,
    height: 41.1719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1688_13015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1688_13015",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTick);
export default __webpack_public_path__ + "static/media/orange-tick.dc08c79da943040f447aaf8f855ea21c.svg";
export { ForwardRef as ReactComponent };